import React, { useEffect, useRef, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./UseAssistant.scss";
import TextChatAssistant from "../ChatAssistant/TextChatAssistant/TextChatAssistant";
import { getAssistantInfo } from "../../api/assistant.api";
import _ from "lodash";
import ShimmerScreen from "../../components/ShimmerScreen";
import FormikFormComponent from "../../components/Plugin/FormComponent/FormikFormComponent";
import SavedContextComponent from "../../components/Plugin/FormComponent/SavedContextComponent";
import axios from "axios";
import Utils from "../../utils";
import ChatHistoryListing from "../ChatAssistant/ChatHistoryListing/ChatHistoryListing";
import {
  ChatAssistantHistory,
  generateAssitantInstanceUUID,
} from "../../api/instance_api";
import moment from "moment/moment";
import BackToTop from "../../components/BackToTopScreen/BackToTop";
import { t } from "i18next";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { toast } from "react-toastify";
import { useLocation, useParams } from 'react-router-dom';

const UseAssistant = ({ assistantId, uuid, markFlag = false }) => {
  const fileInputRef = useRef(null);
  const token = Utils.getLocalStorageItem("_t");
  const proxy = Utils.getLocalStorageItem("_proxy");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const stateValue = queryParams.get('state'); // Gets the 'state' parameter

  const [assistantData, setAssistantData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [fileName, setFileName] = useState(
    "No file selected (Max. limit 1 MB)"
  );
  const [uiElements, setUiElements] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [userQuestion, setUserQuestion] = useState("");
  const [userFormData, setUserFormData] = useState({});
  const [userFilelist, setUserFilelist] = useState({});
  const [activeTab, setActiveTab] = useState("savedContext");
  const [instanceUuId, setInstanceUuId] = useState(null);
  const [instanceList, setInstanceList] = useState([]);
  const [contextColumns, setContextColumns] = useState([]);
  const [currentInstanceId, setCurrentInstanceId] = useState("");
  const [contextId, setContextId] = useState("");
  const [initialValues, setInitialValues] = useState({});
  const [filelist, setFilelist] = useState([]);
  const [instanceName, setInstanceName] = useState("");
  const [instanceObj, setInstanceObj] = useState({});
  const [myInstanceUuid, setMyInstanceUuid] = useState(null);
  const [configk, setConfigk] = useState(null);

  // const assistantData = { uuid: "some-uuid" };
  // const t = (key) => key; // Mock translation function
  const [chatHistory, setChatHistory] = useState([
    "Today",
    // "Yesterday",
    "Current week",
    "Last 7 days", // "Last week",
    // "Two weeks ago",
    // "Three weeks ago",
    // "Current month",
    "Last 30 days", // "Last month",
    // "Older",
  ]);
  const [formData, setFormData] = useState({});
  const [isFetchFormData, setIsFetchFormData] = useState(false);
  const [historyValue, setHistoryValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [noContext, setNoConext] = useState(false);
  const [draftFound, setDraftFound] = useState(false);
  const [dataurl, setDataUrl] = useState([]);
  const [historyFlag, setHistoryFlag] = useState(false);
  const [outputType, setOutputType] = useState("input");
  const currentUser = JSON.parse(Utils.getLocalStorageItem("currentUser"));
  const proxyUser = JSON.parse(Utils.getLocalStorageItem("_proxyuser"));
  const initialMessages = [
    {
      type: "system",
      message: assistantData?.greet
        ? assistantData?.greet
        : "Hi there! How can I help ?",
      status: "completed",
      time: moment().format("DD/MM/YYYY hh:mm A"),
    },
  ];

  const handleDataurlUpdate = (updatedDataurl) => {
    setDataUrl(updatedDataurl);
  };
  const [messages, setMessages] = useState(initialMessages);
  const eventSessionRef = useRef(null);
  const eventChatCreationRef = useRef(null);
  let onHistoryFilterChangesHandler = async (type, historyCheck = false) => {
    if (!loading) {
      setLoading(true);
      setHistoryValue(type);
      let endDate = moment().endOf("day").toISOString();
      let startDate = moment();

      if (type == "Today") {
        startDate.startOf("day");
      } else if (type == "Yesterday") {
        startDate.subtract(1, "day").startOf("day");
      } else if (type == "Current week") {
        startDate.startOf("isoWeek");
      } else if (type == "Last week" || type == "Last 7 days") {
        startDate.subtract(1, "week").startOf("isoWeek");
      } else if (type == "Two weeks ago") {
        startDate.subtract(2, "weeks").startOf("isoWeek");
      } else if (type == "Three weeks ago") {
        startDate.subtract(3, "weeks").startOf("isoWeek");
      } else if (type == "Current month") {
        startDate.startOf("month");
      } else if (type == "Last month" || type == "Last 30 days") {
        startDate.subtract(1, "month").startOf("month");
      } else if (type == "Older") {
        startDate.subtract(3, "month").startOf("month");
      }
      try {
        const systemTimezoneOffset = moment().utcOffset();
        startDate.utcOffset(systemTimezoneOffset);
        endDate = moment(endDate).utcOffset(systemTimezoneOffset).toISOString();

        startDate = startDate.toISOString();

        let payload = {
          type: "history",
          org: "Gen-AI-Studio",
          startDate: startDate,
          endDate: endDate,
          assistantId: uuid,
          instanceid: currentInstanceId,
        };
        if(stateValue === 'openWithOwner'){
          payload.isProxyUser = true;
        }
        let history = await ChatAssistantHistory(
          payload,
          {},
          assistantData.accessToken
        );
        let response = history?.data?.data;
        let newData = 0;
        if (historyCheck) {
          if (response.length == 0) {
            setHistoryFlag(false);
          } else {
            setHistoryFlag(true);
          }
        } else {
          setMessages(initialMessages);
          response.reverse().forEach((data, index) => {
            try {
              var newReponse =
                data?.ai_res?.analysis ||
                data?.ai_res
                  ?.replaceAll("```json", "")
                  ?.replaceAll("```markdown", "")
                  .replaceAll("`", "");
              var repaired = Utils.repairJSON(newReponse);

              let res = {
                data: {
                  answer: "",
                },
              };
              if (repaired) {
                try {
                  res.data.answer = JSON.parse(repaired);
                  if (typeof res.data.answer != "string") {
                    res.data.answer = newReponse;
                  }
                } catch (error) {
                  res.data.answer = repaired;
                  // console.log('res...................150',res)
                }
              } else {
                res.data.answer = newReponse;
                // console.log('res...................154',res)
              }
              // console.log(
              //   "res...................156",
              //   data?.question,data?.question?.length,'................',
              //   res?.data?.answer
              // );
              if (
                data?.question &&
                data?.question?.length != 0 &&
                res?.data?.answer
              ) {
                setMessages((prev) => [
                  ...prev,
                  {
                    type: "user",
                    ishistory: true,
                    message: data?.question,
                    userName: data?.user?.username || "",
                    time: moment
                      .unix(data?.timeStamp)
                      .format("DD/MM/YYYY hh:mm A"),
                  },
                  {
                    type: "system",
                    ishistory: true,
                    message:
                      typeof res?.data?.answer == "string" && res?.data?.answer
                        ? res?.data?.answer
                        : "Please note that I am unable to respond to your query with the information currently available",
                    time: moment
                      .unix(data?.timeStamp)
                      .format("DD/MM/YYYY hh:mm A"),
                  },
                ]);
              }
            } catch (error) {
              console.log("error..........", error);

              newData++;
            }
          });
        }
        setLoading(false);
      } catch (error) {
        console.log("error..........", error);
        setLoading(false);
      }
    }
  };

  const formik = {
    resetForm: (values) => {
      /* Formik resetForm logic */
    },
  };
  // const generateAssistantInstanceData = async (data) => {
  //   // Function to generate assistant instance data
  // };

  const generateAssistantInstanceData = async (data) => {
    let tokenToUse;
    if(stateValue === 'openWithOwner'){
      data.userId = currentUser.emailID
    }
    console.log(tokenToUse,'tokenToUse')
    try {
      await generateAssitantInstanceUUID(data, {
        "x-access-token": tokenToUse,
      })
        .then((response) => {
          if (response.success && !_.isEmpty(response.data)) {
            setInstanceObj(response.data);
            let assistantDataTemp = { ...assistantData };
            assistantDataTemp.instanceData = [
              ...assistantDataTemp.instanceData,
              response.data,
            ];
            setAssistantData(assistantDataTemp);
          }
        })
        .catch((error) => {
          console.error("Something went wrong.", error);
        });
    } catch (err) {
      console.error("Something went wrong.", err);
    } finally {
    }
  };
  const fetchFormData = () => {
    return new Promise((resolve, reject) => {
      setIsFetchFormData(true);
      setTimeout(() => {
        resolve("hello");
      }, 1000);
    });
  };

  useEffect(() => {
    if (uuid) {
      getAssistantDetails(uuid);
      window.scrollTo(0, 0);
    }
    fetchConfig();
  }, [uuid]);

  const refreshChat = () => {
    getAssistantDetails(uuid, true, true);
    window.scrollTo(0, 0);
    setMessages(initialMessages);
    setRefresh(true);
    // setTimeout(() => setRefresh(false), 2000);
  };
  const proxyToken = Utils.getLocalStorageItem("_proxy");
  let TOKEN = stateValue ==='openWithOwner' ? proxyToken : token;

  const getAssistantDetails = async (
    id,
    callLoading = true,
    isRefresh = false,
    savedContext
  ) => {
    try {
      callLoading && setIsLoading(true);
      const response = await getAssistantInfo(id);
      const { data } = response || {};
      const assistantDetailData = data;

      // console.log(assistantDetailData?.instanceData,initialValues,instanceName,currentInstanceId);
      // if(currentInstanceId&&currentInstanceId!=""&&assistantDetailData?.instanceData?.length>0){
      //   assistantDetailData?.instanceData?.forEach((instance)=>{
      //     if(instance?.instanceUuid==currentInstanceId&&instance?.instanceFormData.length>0){
      //       let initialValuesTemp={}
      //       instance?.instanceFormData.forEach((item)=>{
      //         initialValuesTemp={...initialValuesTemp,[item?.id]:item?.value}
      //       })
      //       console.log(initialValuesTemp);
      //        setInitialValues(initialValuesTemp)
      //     }
      //   });
      // }
      if (!_.isEmpty(assistantDetailData)) {
        const response = await fetchChatToken(
          assistantDetailData?.pluginId,
          assistantDetailData?.uuid
        );
        if (assistantDetailData?.outputType) {
          setOutputType(assistantDetailData?.outputType);
        }
        if (!_.isEmpty(response)) {
          const respData = response?.data;
          setMyInstanceUuid(
            assistantDetailData?.instanceData?.[0]?.instanceUuid
          );

          // console.log('267',myInstanceUuid,respData.data)
          if (!_.isEmpty(respData?.data)) {
            const accessToken = respData?.data?.accessToken;
            const assistantInfo = _.clone(assistantDetailData);
            // console.log(assistantDetailData,assistantInfo)
            assistantInfo.accessToken = accessToken;
            setAssistantData(assistantInfo);
            if (!isRefresh) {
              if (
                !assistantInfo?.inputUi ||
                assistantInfo?.inputUi?.length === 0
              ) {
                setActiveTab("chat");
              } else {
                setActiveTab("savedContext");
              }
            }
          }
        }
      }
    } catch (error) {
      setAssistantData({});
    } finally {
      callLoading && setIsLoading(false);
    }
  };
  const getEmptyValues = (values) => {
    const emptyValues = {};
    for (const key in values) {
      if (typeof values[key] === "object" && values[key] !== null) {
        emptyValues[key] = getEmptyValues(values[key]);
      } else {
        emptyValues[key] = "";
      }
    }
    setInstanceObj(emptyValues);
    return emptyValues;
  };
  const fetchDataShared = async () => {
    let endDate = moment().endOf("day").toISOString();
    let startDate = moment();
    const systemTimezoneOffset = moment().utcOffset();
    startDate.utcOffset(systemTimezoneOffset);
    endDate = moment(endDate).utcOffset(systemTimezoneOffset).toISOString();

    const payload = {
      type: "history",
      org: "Gen-AI-Studio",
      startDate: startDate,
      endDate: endDate,
      assistantId: uuid,
      instanceid: currentInstanceId,
    };
    
    if(stateValue === 'openWithOwner'){
      payload.isProxyUser = true;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL +
          process.env.REACT_APP_PREDICTION_HISTORY_URL
          }/shared`,
        {
          headers: {
            "X-Access-Token": token,
          },
          ...payload,
        }
      );

      startDate = startDate.toISOString();

      if (!_.isEmpty(response)) {
        setMessages(initialMessages);
        response?.data?.data?.reverse().forEach((data, index) => {
          try {
            // Replaced markdown logic bottom to top
            let rawResponse =
              data?.ai_res?.analysis ||
              data?.ai_res
                ?.replaceAll("```json", "")
                ?.replaceAll("```markdown", "")
                .replaceAll("`", "");

            let repairedResponse = Utils.repairJSON(rawResponse);
            let responseAnswer = "";

            if (repairedResponse) {
              try {
                responseAnswer = JSON.parse(repairedResponse);
                if (typeof responseAnswer !== "string") {
                  responseAnswer = rawResponse;
                }
              } catch (error) {
                responseAnswer = repairedResponse;
              }
            } else {
              responseAnswer = rawResponse;
            }
            const userMSG = {
              type: "user",
              message: data?.question || "",
              time: moment.unix(data?.timeStamp).format("DD/MM/YYYY hh:mm A"),
              userName: data?.user?.username || "",
            };
            const AI_MSG = {
              type: "system",
              message: responseAnswer,
              status: "completed",
              time: moment.unix(data?.timeStamp).format("DD/MM/YYYY hh:mm A"),
              userName: assistantData.assistantName,
            };

            if (
              data?.question &&
              data?.question.length !== 0 &&
              responseAnswer
            ) {
              setMessages((prev) => [...prev, userMSG, AI_MSG]);
            }
          } catch (error) {
            console.log("Error processing message:", error);
          }
        });
      }
    } catch (error) {}
  };
  const getUsersByInstanceName = (instanceData, instanceName) => {
    const instance = instanceData?.find(
      (item) => item.instanceName === instanceName
    );
    return instance?.users?.length > 0;
  };

  const fetchChatToken = (pluginId, assistantId) =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_GENAI_STUDIO_URL}plugins-api/v1/apps/validatetoken`,
          {
            pluginId,
            assistantId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              accessToken: TOKEN,
            },
          }
        );
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  useEffect(() => {
    setMessages(initialMessages);
  }, [instanceName]);

  const reset = () => {
    // console.log(document.getElementsByClassName('select-input')[0].innerHTML,'.....................',document.getElementsByClassName('select-input')[0].value)
    document.querySelectorAll(".select-input").forEach((element) => {
      element.innerHTML = "";
      element.value = "";
    });
  };

  useEffect(() => {
    if (!historyFlag && assistantData.accessToken) {
      onHistoryFilterChangesHandler("Older", true);
    }
  }, [messages]);

  useEffect(() => {
    if (activeTab === "context" && eventChatCreationRef.current) {
      eventChatCreationRef.current.close();
      eventChatCreationRef.current = null;
    }

    if (activeTab === "chat" && eventSessionRef.current) {
      if (eventSessionRef.current) {
        eventSessionRef.current.close();
        eventSessionRef.current = null;
      }

      createSseConnection(instanceUuId);
    }
  }, [activeTab, instanceUuId]);

  let retryCount = 0;
  const maxRetries = 10;

  const createSseConnection = async (instance) => {
    const baseUrl = process.env.REACT_APP_GENAI_STUDIO_URL;
    const teamChatPath = "plugins-api/v1/apps/team/chat/";
    let userId;
    if(stateValue === 'openWithOwner'){
      userId = await encodeURIComponent(proxyUser._id)
    }else{
      userId = await encodeURIComponent(currentUser.uuid);
    }

    const connectSSE = () => {
      eventChatCreationRef.current = new EventSource(
        `${baseUrl}${teamChatPath}?userid=${userId}&contextId=${instance?.instanceUuid}&orgId=${currentUser?.orgId}`
      );

      eventChatCreationRef.current.addEventListener(
        "message",
        async (event) => {
          const response =
            typeof event.data === "string" ? JSON.parse(event.data) : null;

          if (response) {
            switch (response.eventType) {
              case "Conversation":
                handleConversationSSECallback(response);
                break;
            }
          }
        }
      );

      eventChatCreationRef.current.addEventListener("error", (event) => {
        console.error("Error:", event);

        eventChatCreationRef.current.close();
        eventChatCreationRef.current = null;

        if (retryCount < maxRetries) {
          retryCount++;
          const retryDelay = Math.min(1000 * 2 ** retryCount, 60000);
          setTimeout(connectSSE, retryDelay);
        } else {
          console.error("Max retries reached. Could not reconnect to SSE.");
        }
      });
    };

    connectSSE();
  };

  const handleConversationSSECallback = (response) => {
    if (response?.userId !== currentUser.emailID) {
      if (response?.ai_res) {
        const CONVERSAION_RESPONSE = response?.ai_res;
        const userMSG = {
          type: "system",
          message: response?.question || "",
          time: moment().format("DD/MM/YYYY hh:mm A"),
          userName: response?.userFullName || "",
        };
        setMessages((prev) => [...prev, userMSG]);

        const AI_MSG = {
          type: "system",
          message: CONVERSAION_RESPONSE,
          status: "completed",
          time: moment().format("DD/MM/YYYY hh:mm A"),
          userName: assistantData.assistantName,
        };
        setMessages((prev) => [...prev, AI_MSG]);
      }
    }
  };
  const fetchConfig = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}filehandler/config`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Access-Token": token,
          },
        }
      );

      if (!response.ok) {
        console.error("Failed to fetch configuration!");
        return;
      }

      const configData = await response.json();
      setConfigk(configData?.data);
    } catch (error) {
      console.error("Error fetching configuration:", error);
    }
  };

  const startSession = () => {
    const TOKEN = stateValue ==='openWithOwner' ? proxy : token;
    eventSessionRef.current = new EventSource(
      `${process.env.REACT_APP_BASE_URL}/event/startSession/${TOKEN}`
    );

    eventSessionRef.current.onmessage = (event) => {
      const receivedData = JSON.parse(event.data);
      if (receivedData?.status === "Y" && receivedData?.active == true) {
        toast.success("File processed successfully !!");
        setFilelist((prev) =>
          prev.map((data) => {
            if (data.fileName === receivedData.fileName) {
              data.status = "Y";
              data.message = "";
              data.isProcessed = true;
              data.step = 4;
            }
            return data;
          })
        );
      }
      if (receivedData?.status === "N" && receivedData?.progress) {
        let step = 1;
        let message = receivedData?.progress?.message + '. Please wait...' || "";
        // let baseProgress = 25;
        // let stepProgress = step * 25;
        // let updatedProgress = Math.min(baseProgress + stepProgress, 100); 
    
        setFilelist((prev) =>{
          const newData = prev.map((data) =>
            data.fileName === receivedData.fileName
              ? { ...data,
                message: message,
                isProcessed: false,
                step,
               }
              : data
          );
          return newData;
      });
      }

      if(receivedData?.status === "I"){
        let step = 2;
        let message = "Processing started. Preparing data for analysis...";

        if (receivedData.proccessedChunks > 0) {
          step = 3;
          message = `Processing in progress: ${receivedData.proccessedChunks} out of ${receivedData.totalChunks} chunks completed.`;
        }

        // const updatedProgress = Math.min(25 + step * 25, 100);
        setFilelist((prev) =>{
          const newData = prev.map((data) =>
            data.fileName === receivedData.fileName
              ? { ...data,
                step,
                message: message,
                isProcessed: false,
               }
              : data
          );
          return newData;
      });
      }
      if(receivedData?.status === "E"){
        setFilelist((prev) =>
          prev.map((data) => {
            if (data.fileName === receivedData.fileName) {
              data.status = "E";
              data.message = "";
              data.isProcessed = true;
              data.step = 4;
            }
            return data;
          })
        );
      }
    };
    eventSessionRef.current.onerror = (error) => {
      console.error("EventSource error:", error);
      eventSessionRef.current.close();
    };
  };

useEffect(()=> {
  if(activeTab === "context"){
    startSession();
  }
},[activeTab]);

  return (
    <section className="builder-page-wrapper-class use-assitant-page">
      {/* <BuildSideBarMenu /> */}
      <section className="builder-right-wrapper-class">
        <div className="build-assistant-container pt-3 pb-0">
          <div className="inner-body-of-form useass-inner-body-of-form mt-0">
            <div className="row">
              <div className="col-12 col-md-12">
                <div className="fomr-wrapper-assits">
                  <div className="title-wrapper">
                    <div className="chat-promp-img">
                      {isLoading ? (
                        <ShimmerScreen
                          case="rect"
                          width="3rem"
                          height="3rem"
                          borderRadius="0.5rem"
                        />
                      ) : assistantData.thumbnailUrl ? (
                        <img
                          className="thumbnail-img"
                          width="3rem"
                          height="3rem"
                          src={assistantData.thumbnailUrl}
                          alt={assistantData.assistantName}
                        />
                      ) : (
                        <img
                          className="thumbnail-img-default"
                          width="3rem"
                          height="3rem"
                          style={{ borderRadius: "100%" }}
                          src="/images/default-chat.png"
                          alt="chat"
                        />
                      )}
                    </div>
                    <div className="d-flex flex-column promt-text border-btm">
                      <div className="info-box-header-chat">
                        <div className="heading-box">
                          <h4 className="instruct-title-main">
                            {isLoading ? (
                              <ShimmerScreen
                                case="rect"
                                width="100%"
                                height="2rem"
                                borderRadius="0.8rem"
                              />
                            ) : (
                              assistantData.assistantName
                            )}
                          </h4>
                        </div>
                        <p className="description">
                          {/* Upload PDF files and talk to them like they were a person */}
                          {isLoading ? (
                            <ShimmerScreen
                              case="rect"
                              width="100%"
                              height="1rem"
                              borderRadius="0.8rem"
                            />
                          ) : (
                            assistantData.assistantDescription
                          )}
                        </p>
                      </div>

                      <div className="tabs-wrapper mt-4">
                        {assistantData?.inputUi?.length > 0 && (
                          <div className="text-areabox d-flex w-100 justify-content-end">
                            <div className="d-flex gap-3">
                              <button
                                type="button"
                                className="upload-btn colored"
                                onClick={async () => {
                                  if (
                                    instanceList.findIndex(
                                      (data) => data.status == "Draft"
                                    ) != -1
                                  ) {
                                    setDraftFound(true);
                                  } else {
                                    formik.resetForm({
                                      values: getEmptyValues(initialValues),
                                    });
                                    setFilelist([]);
                                    setInstanceName("");
                                    setCurrentInstanceId("");
                                    setInitialValues({});
                                    setNoConext(true);
                                    setActiveTab("context");
                                    setDataUrl([]);
                                    await generateAssistantInstanceData({
                                      assistantUuid: assistantData.uuid,
                                    });
                                  }
                                  reset();
                                }}
                              >
                                <svg
                                  width="22"
                                  height="22"
                                  viewBox="0 0 22 22"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M11 7V15M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                                    stroke="white"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                {t("instancePopUpAddName")}
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="tab-wrap position-relative">
                          <Tabs
                            onSelect={(k) => setActiveTab(k)}
                            activeKey={activeTab}
                            defaultActiveKey="context"
                            className="mb-3"
                          >
                            {assistantData?.inputUi?.length > 0 && (
                              <Tab eventKey="context" title="Context">
                                {isLoading ? (
                                  <div className="upload-file-box mt-4">
                                    <label htmlFor="name">
                                      <ShimmerScreen
                                        case="rect"
                                        width="20rem"
                                        height="1rem"
                                        borderRadius="0.8rem"
                                      />
                                    </label>
                                    <div>
                                      <ShimmerScreen
                                        case="rect"
                                        width="20rem"
                                        height="2rem"
                                        borderRadius="0.8rem"
                                      />
                                    </div>
                                    <div className="mt-2">
                                      <ShimmerScreen
                                        case="rect"
                                        width="20rem"
                                        height="2rem"
                                        borderRadius="0.8rem"
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                <div
                                  className="reset-box"
                                  style={{ justifyContent: "end" }}
                                >
                                  {instanceName != "" && (
                                    <div className="context-name">
                                      Context in use :{" "}
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip id="tooltip-disabled">
                                            {instanceName}
                                          </Tooltip>
                                        }
                                      >
                                        <span className="badge">
                                          {instanceName}
                                        </span>
                                      </OverlayTrigger>
                                    </div>
                                  )}
                                </div>
                                <FormikFormComponent
                                  uuid={uuid}
                                  isLoading={isLoading}
                                  assistantData={assistantData}
                                  inputUi={assistantData?.inputUi}
                                  isFormLoading={isFormLoading}
                                  accessToken={assistantData.accessToken}
                                  setIsFormLoading={setIsFormLoading}
                                  setUserFormData={setUserFormData}
                                  setUserQuestion={setUserQuestion}
                                  setUserFilelist={setUserFilelist}
                                  fetchFormData={isFetchFormData}
                                  setFetchFormData={setIsFetchFormData}
                                  setFormData={setFormData}
                                  referenceId={uuid}
                                  getAssistantDetails={getAssistantDetails}
                                  fetchChatToken={fetchChatToken}
                                  setAssistantData={setAssistantData}
                                  setInstanceList={setInstanceList}
                                  instanceList={instanceList}
                                  setCurrentInstanceId={setCurrentInstanceId}
                                  setContextId={setContextId}
                                  currentInstanceId={currentInstanceId}
                                  setInstanceName={setInstanceName}
                                  instanceName={instanceName}
                                  setContextId={setContextId}
                                  setInitialValues={setInitialValues}
                                  initialValues={initialValues}
                                  setFilelist={setFilelist}
                                  filelist={filelist}
                                  setInstanceObj={setInstanceObj}
                                  instanceObj={instanceObj}
                                  getEmptyValues={getEmptyValues}
                                  setActiveTab={setActiveTab}
                                  draftFound={draftFound}
                                  setDraftFound={setDraftFound}
                                  refresh={refresh}
                                  setInstanceUuId={setInstanceUuId}
                                  setRefresh={setRefresh}
                                  dataurl={dataurl}
                                  setDataUrl={setDataUrl}
                                  reset={reset}
                                  createSseConnection={createSseConnection}
                                  eventSessionRef={eventSessionRef}
                                  eventChatCreationRef={eventChatCreationRef}
                                  activeTab={activeTab}
                                  setInstanceUuId={setInstanceUuId}
                                  configk={configk}
                                  onDataurlUpdate={handleDataurlUpdate}
                                />
                              </Tab>
                            )}
                            {assistantData?.inputUi?.length > 0 && (
                              <Tab
                                eventKey="savedContext"
                                title="Saved Context"
                              >
                                <div
                                  className="reset-box"
                                  style={{ justifyContent: "end" }}
                                >
                                  {instanceName != "" && (
                                    <div className="context-name">
                                      Context in use :{" "}
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip id="tooltip-disabled">
                                            {instanceName}
                                          </Tooltip>
                                        }
                                      >
                                        <span className="badge">
                                          {instanceName}
                                        </span>
                                      </OverlayTrigger>
                                    </div>
                                  )}
                                </div>
                                <SavedContextComponent
                                  instanceList={instanceList}
                                  currentInstanceId={currentInstanceId}
                                  instanceData={assistantData?.instanceData}
                                  stateValue={stateValue}
                                />
                              </Tab>
                            )}
                            <Tab eventKey="chat" title="Ask AI">
                              <div
                                className="reset-box"
                                style={{ justifyContent: "end" }}
                              >
                                {instanceName != "" && (
                                  <div className="context-name">
                                    Context in use :{" "}
                                    {/* <Badge bg="primary">{instanceName}</Badge> */}
                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip id="tooltip-disabled">
                                          {instanceName}
                                        </Tooltip>
                                      }
                                    >
                                      <span className="badge">
                                        {instanceName}
                                      </span>
                                    </OverlayTrigger>
                                  </div>
                                )}
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip id="tooltip-disabled">
                                      Refresh
                                    </Tooltip>
                                  }
                                >
                                  <button
                                    //variant="light"
                                    //style={{ width: "40px" }}
                                    onClick={() => {
                                      if (
                                        getUsersByInstanceName(
                                          assistantData?.instanceData,
                                          instanceName
                                        )
                                      ) {
                                        fetchDataShared();
                                      } else {
                                        refreshChat();
                                      }
                                      setHistoryValue("");
                                    }}
                                    //title="Refresh"
                                    className="rfresh-btn"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      class="bi bi-arrow-clockwise"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                                      />
                                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                                    </svg>
                                  </button>
                                </OverlayTrigger>
                              </div>
                              <div className="row">
                                {/* {historyFlag && ( */}
                                <div
                                  className={`col-lg-3 col-md-12 ${
                                    isLoading || isStreaming
                                      ? "chat-history-disabled"
                                      : ""
                                  }`}
                                >
                                  <ChatHistoryListing
                                    selected={historyValue}
                                    listingArr={chatHistory}
                                    onClickHandler={
                                      onHistoryFilterChangesHandler
                                    }
                                  />
                                </div>
                                {/* )} */}
                                <div
                                  className={`col-lg-${
                                    // historyFlag ? "9" : "12"
                                    "9"
                                  } col-md-12`}
                                >
                                  <div className="instruct-show">
                                    <div>
                                      {activeTab === "chat" && (
                                        <TextChatAssistant
                                        activeTab={activeTab}
                                        initialMessages={initialMessages}
                                        userMessage={userQuestion}
                                        setUserMessage={setUserQuestion}
                                        userFormData={userFormData}
                                        uuid={assistantData.uuid}
                                        accessToken={assistantData.accessToken}
                                        pluginId={assistantData.pluginId}
                                        setIsFormLoading={setIsFormLoading}
                                        userFilelist={userFilelist}
                                        getFormData={fetchFormData}
                                        loading={loading}
                                        setLoading={setLoading}
                                        messages={messages}
                                        setMessages={setMessages}
                                        markFlag={markFlag}
                                        autostart={assistantData?.autoStart}
                                        chunks={assistantData?.chunks}
                                        chunkFlag={assistantData?.chunksPrompt}
                                        isStreaming={isStreaming}
                                        setIsStreaming={setIsStreaming}
                                        title={assistantData.assistantName}
                                        instanceName={instanceName}
                                        initialValues={initialValues}
                                        currentInstanceId={currentInstanceId}
                                        contextId={contextId}
                                        refresh={refresh}
                                        instanceObj={instanceObj}
                                        outputType={outputType}
                                        shouldShowAudioIcon={
                                          assistantData?.isAudioEnabled
                                        }
                                        instanceData={
                                          assistantData.instanceData
                                        }
                                        fetchDataShared={fetchDataShared}
                                        getUsersByInstanceName={
                                          getUsersByInstanceName
                                        }
                                      />
                                      )}
                                    </div>
                                    {/* <div className="instruct-box-wrap">
                                <h5>Input</h5>
                                <p>
                                  tell me how to build a great digital marketing campaign
                                </p>
                              </div>
                              <div className="instruct-box-wrap">
                                <h5>Output</h5>
                                <p>
                                  Building a great digital marketing campaign involves a
                                  combination of strategic planning, understanding your
                                  audience, and leveraging various digital channels
                                  effectively. Here’s a step-by-step guide to help you
                                  create a successful digital marketing campaign:
                                </p>
                                <p>1. Define Your Goals</p>
                                <ul>
                                  <li>
                                    Specific: Clearly define what you want to achieve
                                    (e.g., increase website traffic by 20%).
                                  </li>

                                  <li>
                                    Measurable: Ensure you can track your progress (e.g.,
                                    using Google Analytics).
                                  </li>
                                  <li>
                                    Achievable: Set realistic goals based on your
                                    resources and market conditions.
                                  </li>
                                  <li>
                                    Relevant: Align your goals with your overall business
                                    objectives. Time-bound: Set a deadline for achieving
                                    your goals.
                                  </li>
                                </ul>
                                <p>2. Understand Your Audience</p>
                                <ul>
                                  <li>
                                    Demographics: Age, gender, location, income,
                                    education.
                                  </li>
                                  <li>
                                    Psychographics: Interests, values, lifestyle,
                                    behavior.
                                  </li>
                                  <li>
                                    Customer Personas: Create detailed profiles of your
                                    ideal customers to tailor your messaging.
                                  </li>
                                </ul>

                                <p>3. Conduct Market Research</p>
                                <ul>
                                  <li>
                                    Competitor Analysis: Identify your competitors,
                                    analyze their strategies, and find gaps you can
                                    exploit.
                                  </li>
                                  <li>
                                    SWOT Analysis: Assess your strengths, weaknesses,
                                    opportunities, and threats.
                                  </li>
                                </ul>
                              </div> */}
                                  </div>
                                </div>
                              </div>
                            </Tab>
                          </Tabs>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BackToTop />
    </section>
  );
};

export default UseAssistant;
